exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wv-list-item-icon{margin-right:25px;align-self:flex-start;display:block;width:40px;height:40px}.wv-list-item-ruler{background-color:var(--primaryVariant1);height:1px;margin-top:19px}.wv-list-item-content{width:100%;align-self:flex-start}", ""]);

// exports
